import { useContext, useEffect, useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import DisplayUsage from "./components/DisplayUsage"
import { AdminQueryProduct, AdminQueryUsage } from "../../backend/src/api/dto"
import ModalConfirmation from "./Modal/Confirmation"

type FormValues = {
    name: string
    description: string
    status: boolean
}


function Product() {

    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<{
        product: AdminQueryProduct,
        usage: AdminQueryUsage[],
    }>({
        product: {
            productId: 0,
            name: '',
            description: '',
            status: false
        },
        usage: []
    })
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(false)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.productId !== "0") {
                const product = await API.getProduct(params.productId ?? 0)
                setData(prevData => {
                    return {
                        ...prevData,
                        ...product
                    }
                })
                setLoading(false)
                return product.product
            } else {
                setLoading(false)
                return {
                    status: true,
                    name: '',
                    description: ''
                }
            }
        }
    })

    const reloadData = (): Promise<any> => {
        setLoading(true)
        return API.getProduct(params.productId ?? 0).then(product => {
            setData(prevData => {
                return {
                    ...prevData,
                    ...product,

                }
            })
            setLoading(false)
        }).catch(e => {
            setLoading(false)
        })
    }



    useEffect(() => {
        if (params.productId !== "0") {
            reloadData()
        }
    }, [params.productId])

    const addProduct = () => {
        API.addProduct(getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/product')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const saveProduct = () => {
        API.saveProduct(params.productId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/product')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const deleteProduct = () => {
        return API.deleteProduct(params.productId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/product')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Produkt: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/product" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Produkt: <strong>{
                                params.productId === "0" ? '[ Vytvoriť nový ]' : getValues().name
                            }</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            {
                                params.productId === "0" ?
                                    <button className="btn btn-primary" onClick={addProduct}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať produckt</button>
                                    :
                                    <>
                                        {
                                            !loading && !data.usage.length ?
                                                <button className="btn btn-danger me-3" onClick={() => showModal(
                                                    <ModalConfirmation
                                                        confirm={deleteProduct}
                                                        title={"Naozaj zmazať produkt?"}
                                                        text="" />
                                                )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať produkt</button>
                                                : null

                                        }
                                        <button className="btn btn-primary" onClick={saveProduct}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť produkt</button>
                                    </>

                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <ApiResult errorObject={apiResult} />

                    <div className="row">
                        <div className="col-4">

                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov produktu</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Popis</label>
                                </div>
                                <div className="col-8">
                                    <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-4  mt-1 text-end">
                                    <label className="form-label">Aktívny</label>
                                </div>
                                <div className="col-8  mt-1">
                                    <div className="form-check">

                                        <input className="form-check-input" {...register("status")} type="checkbox" />
                                        <label className="form-check-label">

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="offset-4 col-4">
                            {
                                params.productId !== "0" ?
                                    <>
                                        <h4>Odkazy na tento produkt</h4>
                                        <DisplayUsage data={data.usage} />
                                    </>
                                    : null
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Product